<style lang="less">
    @import "../../global/font/iconfont.css";
    .buildAsets{
        border: 1px solid #d7dde4;
        background: #efefef;
        height: 100%;
        position: relative;
        .head{
            /*height: 46px;*/
            padding-top: 10px;
            border-bottom: 1px solid #d7dde4;
            margin-bottom: 20px;
            h1{
                display: inline;
                margin-left: 20px;
                color: #00c0ff;

                };
        }
        .layout-content{
            min-height: 80vh;
            margin: 15px;
            overflow: hidden;
            background: #fff;
            border-radius: 4px;
            .main-content{
                padding-left:10px;
                .image-view {
                    text-align: center;
                    position: fixed;
                    top: 0;
                    right: 0;
                    bottom: 0;
                    left: 0;
                    background-color: #000000;
                    z-index: 1000;
                img{
                    width: auto;
                    height: auto;
                    max-width: 100%;
                    max-height: 100%;
                    }
                }
                .remark-img-part {
                .img-list {
                .img-item {
                    position: relative;
                    float: left;
                    margin-right: 9px;
                    margin-bottom: 9px;
                    width: 79px;
                    height: 79px;
                    background: no-repeat 50%;
                    background-size: cover;
                .icon-remove {2
                position: absolute;
                    right: 2px;
                    top: 2px;
                    padding: 0px 5px;
                    cursor: pointer;
                    border-radius: 50%;
                    background: #FF4949;
                    color: #fff;
                    display: -webkit-box;
                    display: -webkit-flex;
                    display: -ms-flexbox;
                    display: none;
                    -webkit-box-align: center;
                    -webkit-align-items: center;
                    -ms-flex-align: center;
                    align-items: center;
                    justify-content: center;
                    -webkit-user-select: none;
                    -moz-user-select: none;
                    -ms-user-select: none;
                    user-select: none;
                }
                }
                .img-item:hover{
                .icon-remove {
                    display:flex;
                }
                }
                }
                .uploader_input_wrp {
                    cursor: pointer;
                    float: left;
                    position: relative;
                    margin-right: 9px;
                    margin-bottom: 9px;
                    width: 79px;
                    height: 79px;
                    border: 1px solid #d9d9d9;
                }
                .uploader_input_wrp:before{
                    width: 2px;
                    height: 39.5px;
                }
                .uploader_input_wrp:after{
                    width: 39.5px;
                    height: 2px;
                }
                .uploader_input_wrp:before,.uploader_input_wrp:after {
                    content: " ";
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    -webkit-transform: translate(-50%,-50%);
                    transform: translate(-50%,-50%);
                    background-color: #d9d9d9;
                }
                }
                .footer{
                    text-align: center;
                }
                        }
                    }
        .demo-spin-icon-load{
            animation: ani-demo-spin 1s linear infinite;
        }
        @keyframes ani-demo-spin {
            from { transform: rotate(0deg);}
            50%  { transform: rotate(180deg);}
            to   { transform: rotate(360deg);}
        }
        .demo-spin-col{
            height: 10px;
            position: relative;
            /*border: 1px solid #eee;*/
        }


    }




</style>
<template>
    <div class="buildAsets">
        <Row>

            <i-col span="24">
                <div class="layout-content">
                    <div class="head">
                        <h1 >{{updateTitle}}</h1>
                    </div>
                    <div class="main-content">
                        <div class="demo-spin-col"  span="24">
                            <Spin fix v-if="loading">
                                <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
                                <div>上传中...</div>
                            </Spin>
                        </div>
                        <div class="form-body">
                            <div>
                                <span>资产合同</span>
                                <div class="remark-img-part">
                                    <ul class="img-list">
                                        <li class="img-item" v-for="imgItem in assetsTable.contract_image" title="双击查看大图" :style="{'background-image':'url('+urlPrefix+imgItem+'?token='+token+')'}" @dblclick="handleView(true,imgItem)">
                                            <span class="icon-remove" title="点击删除"  @click="handleUploadRemove(imgItem,assetsTable.contract_image)">x</span>
                                        </li>
                                    </ul>
                                    <Upload ref="upload" :format="['jpg','jpeg','png']" :on-progress="isLoading" :headers="{token:this.getKey('token')}" :show-upload-list="false" :action="contractUploadUrl"  :on-success="handleUploadSuccess" :on-format-error="handleFormatError">
                                        <div title="点击上传图片" class="uploader_input_wrp"></div>
                                    </Upload>
                                </div>
                            </div>
                            <div>
                                <span>资产发票</span>
                                <div class="remark-img-part">
                                    <ul class="img-list">
                                        <li class="img-item" v-for="imgItem in assetsTable.invoice_image" title="双击查看大图" :style="{'background-image':'url('+urlPrefix+imgItem+'?token='+token+')'}" @dblclick="handleView(true,imgItem)">
                                            <span class="icon-remove" title="点击删除"  @click="handleUploadRemove(imgItem,assetsTable.invoice_image)">x</span>
                                        </li>
                                    </ul>
                                    <Upload ref="upload" :format="['jpg','jpeg','png']" :on-progress="isLoading" :headers="{token:this.getKey('token')}" :show-upload-list="false" :action="billUploadUrl"  :on-success="handleUploadSuccess" :on-format-error="handleFormatError">
                                        <div title="点击上传图片" class="uploader_input_wrp"></div>
                                    </Upload>
                                </div>
                            </div>
                            <div>
                                <span>资产图片</span>
                                <div class="remark-img-part">
                                    <ul class="img-list">
                                        <li class="img-item" v-for="imgItem in assetsTable.asset_image" title="双击查看大图" :style="{'background-image':'url('+urlPrefix+imgItem+'?token='+token+')'}" @dblclick="handleView(true,imgItem)">
                                            <span class="icon-remove" title="点击删除"  @click="handleUploadRemove(imgItem,assetsTable.asset_image)">x</span>
                                        </li>
                                    </ul>
                                    <Upload ref="upload" :format="['jpg','jpeg','png']" :on-progress="isLoading" :headers="{token:this.getKey('token')}" :show-upload-list="false" :action="assetUploadUrl"  :on-success="handleUploadSuccess" :on-format-error="handleFormatError">
                                        <div title="点击上传图片" class="uploader_input_wrp"></div>
                                    </Upload>
                                </div>
                            </div>
                            <div>
                                <span class="ivu-form-item-label" style="font-size: 14px;">行政事业系统卡片编号</span>
                                <Upload
                                        ref="upload"
                                        :action='adminUploadUrl'
                                        :data="upData_yongyou"
                                        :format="['xls','xlsx']"
                                        :on-format-error="handleError"
                                        :headers="{token:this.getKey('token')}"
                                        :on-success="handleSuccess"
                                        :show-upload-list="false"
                                        style="display: inline-block;margin-left: 20px;"

                                ><Button type="success" v-if="assetsTable.admin_doc.filename ==''" icon="ios-cloud-upload-outline" style="width: 100px;">上传</Button>
                                    <Button type="success" v-if="assetsTable.admin_doc.filename!=''" icon="ios-cloud-upload-outline" style="width: 100px;">重新上传</Button>
                                </Upload>
                                <p style="margin-top: 20px;">{{assetsTable.admin_doc.filename}} <span><i class="iconfont icon-xuanze" v-if="check_hangye_msg==true&&assetsTable.admin_doc.filename!=''" style="color: limegreen"></i>
                                    <i class="iconfont icon-shanchu" v-if="check_hangye_msg==false&&assetsTable.admin_doc.filename!=''" style="color: red"></i>
                                </span></p>
                            </div>
                            <div style="margin-top: 40px;margin-bottom: 40px;">
                                <span class="ivu-form-item-label" style="font-size: 14px;">用友系统卡片编号</span>
                                <Upload
                                        ref="upload"
                                        :action='yongyouUploadUrl'
                                        :data="upData_hangye"
                                        :format="['xls','xlsx']"
                                        :on-format-error="handleError"
                                        :headers="{token:this.getKey('token')}"
                                        :on-success="handleSuccess"
                                        :show-upload-list="false"
                                        style="display: inline-block;margin-left: 20px;"

                                ><Button type="success" v-if="assetsTable.yonyou_doc.filename ==''" icon="ios-cloud-upload-outline" style="width: 100px;">上传</Button>
                                    <Button type="success" v-if="assetsTable.yonyou_doc.filename !=''" icon="ios-cloud-upload-outline" style="width: 100px;">重新上传</Button>

                                </Upload>
                                <p style="margin-top: 20px;">{{assetsTable.yonyou_doc.filename}} <span><i class="iconfont icon-xuanze" v-if="check_yonyou_msg==true&&assetsTable.yonyou_doc.filename!=''" style="color: limegreen"></i>
                                    <i class="iconfont icon-shanchu" v-if="check_yonyou_msg==false&&assetsTable.yonyou_doc.filename!=''" style="color: red"></i>
                                </span></p>
                            </div>
                            <!--<div style="margin-top: 40px;margin-bottom: 40px;" v-if="assetsTable.asset_doc!=''&& assetsTable.asset_doc!=undefined">-->
                                <!--<span class="ivu-form-item-label" style="font-size: 14px;">固定资产验收单</span>-->
                                <!--<Button type="primary"  style="width: 100px;margin-left: 50px;" @click="download_asets">下载</Button>-->
                            <!--</div>-->
                            <div style="margin-top: 40px;margin-bottom: 40px;" v-if="show_bill">
                                <span class="ivu-form-item-label" style="font-size: 14px;">固定资产验收单</span>
                                <Button type="primary"  style="width: 100px;margin-left: 50px;" @click="download_asets">下载</Button>
                            </div>
                            <Form ref="assetsForm" :model="assetsTable" label-position="top" :rules="assets_validate_rules" inline>
                                <div>
                                    <FormItem label="资产信息描述" style="width: 90%;" >
                                        <Input type="textarea" v-model="assetsTable.remarks" style="max-width: 100%;width: 100%" :autosize="{minRows: 2,maxRows: 5}" placeholder="请输入资产描述"></Input>
                                    </FormItem>
                                </div>
                                <FormItem label="固定资产名称" prop="name" >
                                    <Input  v-model="assetsTable.name"></Input>
                                </FormItem>
                                <FormItem label="用友系统卡片编号"  >
                                    <Input  v-model="assetsTable.yonyou_id"></Input>
                                </FormItem>
                                <FormItem label="行政事业系统编号"  >
                                    <Input  v-model="assetsTable.admin_id"></Input>
                                </FormItem>
                                <FormItem label="规格型号"  >
                                    <Input  v-model="assetsTable.model"></Input>
                                </FormItem>
                                <FormItem label="资产分类代码"  >
                                    <Input  v-model="assetsTable.class_code"></Input>
                                </FormItem>
                                <FormItem label="资产所属部门" prop="department" >
                                    <!--<Input  v-model="assetsTable.department"></Input>-->
                                    <Select v-model="assetsTable.department" clearable style="width:162px;display: inline-block">
                                        <Option v-for="item in departmentList" :value="item.name" :key="item.name">{{ item.name }}</Option>
                                    </Select>
                                </FormItem>
                                <FormItem label="资产原值"  >
                                    <Input  v-model="assetsTable.full_price"></Input>
                                </FormItem>
                                <!--<FormItem label="累计折旧"  >-->
                                    <!--<Input  v-model="assetsTable.depreciation"></Input>-->
                                <!--</FormItem>-->
                                <FormItem label="净值"  >
                                    <Input  v-model="assetsTable.net_value"></Input>
                                </FormItem>
                                <FormItem label="资产数量" prop="count" >
                                    <Input  v-model="assetsTable.count" :disabled="edit_count"></Input>
                                </FormItem>
                                <FormItem label="计量单位"  >
                                    <Input  v-model="assetsTable.unit"></Input>
                                </FormItem>
                                <FormItem label="增加方式"  >
                                    <Input  v-model="assetsTable.add_type"></Input>
                                </FormItem>
                                <FormItem label="增加日期"  prop="add_date">
                                    <!--<Input  v-model="assetsTable.add_date"></Input>-->
                                    <DatePicker type="date" v-model="assetsTable.add_date" style="width: 168px"></DatePicker>
                                </FormItem>
                                <FormItem label="入账日期"  >
                                    <!--<Input  v-model="assetsTable.entry_date"></Input>-->
                                    <DatePicker type="date" v-model="assetsTable.entry_date" style="width: 168px"></DatePicker>
                                </FormItem>
                                <FormItem label="入账形式"  >
                                    <Input  v-model="assetsTable.entry_type"></Input>
                                </FormItem>
                                <FormItem label="会计凭证号"  >
                                    <Input  v-model="assetsTable.accounting_id"></Input>
                                </FormItem>
                                <FormItem label="建筑面积"  >
                                    <Input  v-model="assetsTable.build_area"></Input>
                                </FormItem>
                                <FormItem label="车牌号"  >
                                    <Input  v-model="assetsTable.plate_number"></Input>
                                </FormItem>
                                <FormItem label="资金来源"  >
                                    <Input  v-model="assetsTable.fund_source"></Input>
                                </FormItem>
                                <FormItem label="项目名称"  >
                                    <Input  v-model="assetsTable.project_name"></Input>
                                </FormItem>
                                <FormItem label="发票编号"  >
                                    <Input  v-model="assetsTable.invoice_number"></Input>
                                </FormItem>
                                <FormItem label="实物保管人"  >
                                    <Input  v-model="assetsTable.keeper"></Input>
                                </FormItem>
                                <!--<FormItem label="所属单位"  >-->
                                    <!--<Input  v-model="assetsTable.company"></Input>-->
                                <!--</FormItem>-->
                                <FormItem label="所属单位"  >
                                    <Input  v-model="assetsTable.belonged"></Input>
                                </FormItem>
                                <FormItem label="使用状况"  >
                                    <Input  v-model="assetsTable.use_state"></Input>
                                </FormItem>
                                <FormItem label="资产存放地点" prop="location" >
                                    <Input  v-model="assetsTable.location"></Input>
                                </FormItem>
                                <!--<FormItem label="使用年限"  >-->
                                    <!--<Input  v-model="assetsTable.use_year"></Input>-->
                                <!--</FormItem>-->
                                <FormItem label="财务负责人"  >
                                    <Input  v-model="assetsTable.finance_person"></Input>
                                </FormItem>
                                <!--<FormItem label="销账日期">-->
                                    <!--<DatePicker type="date" format="yyyy-MM-dd" v-model="assetsTable.cancel_date"  style="width: 168px"></DatePicker>-->
                                <!--</FormItem>-->
                                <!--<FormItem label="注销人">-->
                                    <!--<Input  v-model="assetsTable.cancel_person"></Input>-->
                                <!--</FormItem>-->
                                <FormItem label="减少方式">
                                    <Input  v-model="assetsTable.cut_type"></Input>
                                </FormItem>
                                <!--<FormItem label="变动日期">-->
                                    <!--<DatePicker type="date" format="yyyy-MM-dd" v-model="assetsTable.change_date" style="width: 168px"></DatePicker>-->
                                <!--</FormItem>-->
                                <!--<FormItem label="变动后使用部门">-->
                                    <!--<Input  v-model="assetsTable.change_dep"></Input>-->
                                <!--</FormItem>-->
                                <FormItem label="使用面积">
                                    <Input  v-model="assetsTable.square"></Input>
                                </FormItem>
                                <FormItem label="供应商">
                                    <Input  v-model="assetsTable.supplier"></Input>
                                </FormItem>
                                <FormItem label="生产厂家">
                                    <Input  v-model="assetsTable.manufacturer"></Input>
                                </FormItem>


                            </Form>

                        </div>
                        <div class="footer">
                            <Button v-if="updateTitle == '资产信息提取'&& isScrap" type="primary" @click="handleSaveCheck('assetsForm','new')">保存并生成固定资产验收单</Button>
                            <Button v-if="updateTitle == '资产信息修改'&& isScrap" type="primary" @click="handleSaveCheck('assetsForm','edit')">修改并生成固定资产验收单</Button>
                            <Button @click="cancel" style="margin-left: 30px;">返回</Button>
                        </div>
                    </div>
                    <div class="image-view" v-show="imageViewVisible" @dblclick="handleView(false)">
                        <img :src="urlPrefix+viewPath+'?token='+token" alt="" title="双击关闭大图">
                    </div>
                    <Modal v-model="modal3">
                        <p slot="header" style="color:#f60;text-align:center">
                            <Icon type="information-circled"></Icon>
                            <span>内容冲突</span>
                        </p>
                        <div style="text-align:center;font-size: 16px;">
                            <p>上传的文件以下内容发生发生冲突，是否确定覆盖?</p>
                            <p>{{error_msg}}</p>
                        </div>
                        <div slot="footer">
                            <Button type="primary" size="large" @click="ok">确定</Button>
                            <Button  size="large" @click="modal3=false">取消</Button>
                        </div>
                    </Modal>
                </div>
            </i-col>


        </Row>
    </div>

</template>

<script>
    import {deepCopy} from 'iview/src/utils/assist';
    export default {
        data () {
            const reEXP_number = /^[1-9]\d*$/;
            const validate_name = (rule,value,callback) =>{
                if(value == '') {
                    callback(new Error('资产名称不能为空！'))
                }else {callback()}
            };
            const validate_department = (rule,value,callback) =>{
                if(value == '') {
                    callback(new Error('所属部门不能为空！'))
                }else {callback()}
            };
            const validate_number = (rule,value,callback) =>{
                if(value == '') {
                    callback(new Error('资产数量不能为空！'))
                }else if (!reEXP_number.test(value)){
                    callback(new Error('资产数量格式不对!'))
                }else {callback()}
            };
            const validate_location = (rule,value,callback) =>{
                if(value == '') {
                    callback(new Error('存放地点不能为空！'))
                }else {callback()}
            };
            const validate_entry_date = (rule,value,callback) =>{
                if(value == '') {
                    callback(new Error('增加日期不能为空！'))
                }else {callback()}
            };
            return {
                assets_validate_rules:{
                    name:[{required:true,validator:validate_name,trigger:'blur'}],
                    count:[{required:true,validator:validate_number,trigger:'blur'}],
                    location:[{required:true,validator:validate_location,trigger:'blur'}],
                    department:[{required:true,validator:validate_department,trigger:'change'}],
                    add_date:[{required:true,validator:validate_entry_date,trigger:'change'}],
                },
                contractUploadUrl:parameters.domain+'/sys/assetlist/uploadcontract',
                billUploadUrl:parameters.domain+'/sys/assetlist/uploadinvoice',
                assetUploadUrl:parameters.domain+'/sys/assetlist/uploadasset',
                adminUploadUrl:parameters.domain+'/sys/assetlist/uploadadmin',
                yongyouUploadUrl:parameters.domain+'/sys/assetlist/uploadyonyou',
                assetdocUploadUrl:parameters.domain+'/sys/assetlist/uploadassetdoc',
                urlPrefix:parameters.domain,
                token:this.getKey('token'),
                updateTitle:'',
                viewPath:'',
                username:'',
                startDate:'',
                endDate:'',
                ql_name:'',
                ql_department:'',
                ql_lend_department:'',
                error_msg:'',
                asets_doc:'',
                imageViewVisible:false,
                columnFieldsModalShow:false,
                check_yonyou_msg:false,
                check_hangye_msg:false,
                asetsTable:false,
                modal3:false,
                isScrap:true,
                show_bill:false,
                edit_count:false,
                loading:false,
                formInline:{},
                upData_yongyou:{},
                upData_hangye:{},
                cover_msg:{},
                currentUploadFileList:[],
                departmentList:[],
                uploadArr:[],
                assetsTable:{
                    name:'',
                    yonyou_id:'',
                    admin_id:'',
                    model:'',
                    class_code:'',
                    department:'',
                    full_price:'',
                    depreciation:'',
                    net_value:'',
                    count:'',
                    can_use_count:'',
                    unit:'',
                    add_type:'',
                    add_date:'',
                    entry_date:'',
                    accounting_id:'',
                    build_area:'',
                    plate_number:'',
                    fund_source:'',
                    project_name:'',
                    invoice_number:'',
                    keeper:'',
                    remarks:'',
                    admin_doc:{filename:'',path:''},
//                    asset_doc:'',
                    yonyou_doc:{filename:'',path:''},
                    manufacturer:'',
                    supplier:'',
                    square:'',
                    change_dep:'',
                    change_date:'',
                    cut_type:'',
                    cancel_person:'',
                    cancel_date:'',
                    finance_person:'',
                    use_year:'',
                    location:'',
                    usr_state:'',
                    company:'',
                    belonged:'',
                    entry_type:'',
                    invoice_image:[],
                    contract_image:[],
                    asset_image:[],
                }
            }

        },
        methods: {
            //部门列表
            getDepartment:function () {
                var that = this;
                var params = {};
                params.data = {};
                params.token = this.getKey('token');
                params.url = '/sys/department/list';
                params.success = function(res) {
                    that.$Loading.finish();
                    console.log(res);
                    that.departmentList = res.data.result.result;
//                    that.recordPage.total = res.result.totalSize
//                    that.dataSourceList.reverse()

                }
                this.ajaxPost(params);
            },
            //保存
            handleSaveCheck:function (formName,type) {
                var that = this;
                console.log(formName);
                this.$refs[formName].validate((valid) =>{
                    console.log(8888);
                    if(valid){
                        console.log(5555);
                        var params = {};
                        that.assetsTable.add_date=new Date(this.assetsTable.add_date).format('yyyy-MM-dd');
                        that.assetsTable.entry_date=new Date(this.assetsTable.entry_date).format('yyyy-MM-dd');
//                        that.assetsTable.cancel_date=new Date(this.assetsTable.cancel_date).format('yyyy-MM-dd');
//                        that.assetsTable.change_date=new Date(this.assetsTable.change_date).format('yyyy-MM-dd');
                        params.token = that.getKey('token');
                        if(type=='new'){
                            params.url = '/sys/assetlist/new';
                        }else if(type=='edit'){
                            params.url = '/sys/assetlist/edit';
                        }
//                        if(that.assetsTable.contract_image.length==0){
//                            that.$Notice.warning({
//                                title: '请上传资产合同图片'
//                            });
//                            return;
//                        }
//                        if(that.assetsTable.invoice_image.length==0){
//                            that.$Notice.warning({
//                                title: '请上传资产发票图片'
//                            });
//                            return;
//                        }
                        if(that.assetsTable.asset_image.length==0){
                            that.$Notice.warning({
                                title: '请上传资产图片'
                            });
                            return;
                        }
//                        if(that.assetsTable.admin_doc.filename==''){
//                            that.$Notice.warning({
//                                title: '请上传行政事业系统卡片编号'
//                            });
//                            return;
//                        }
//                        if(that.assetsTable.yonyou_doc.filename==''){
//                            that.$Notice.warning({
//                                title: '请上传用友系统卡片编号'
//                            });
//                            return;
//                        }
                        params.data = that.assetsTable;
                        params.data.state = '在用';
                        console.log(params.data);
                        params.success = function(res) {
                          console.log(res);
                            that.$Loading.finish();
                            that.$Notice.success({
                                title: '保存成功'
                            });
                            that.updateTitle='资产信息修改'
                            that.assetsTable.asset_doc=res.data.result.asset_doc;
                            that.show_bill=true;
                            console.log(that.assetsTable.asset_doc);
//                    that.$router.push('asetsList')

                        }
                        that.ajaxPost(params);
                    }else{
                        console.log('校验失败');
                    }

                })


            },
//            cancel_date:function (data,type) {
//                console.log(data);
//                console.log(type);
//                var that=this;
//                switch (type){
//                    case 'cancel':
//                        that.assetsTable.cancel_date=data
//                        console.log(that.assetsTable.cancel_date);
//                        break;
//                    case 'change_date':
//                        that.assetsTable.change_date=data
//                        console.log(that.assetsTable.change_date);
//                        break;
//                }
//
//            },
            //继续覆盖冲突字段
            ok:function () {
                console.log(this.cover_msg);
                let that=this
                if(this.cover_msg.type=='Admin'){
                    this.upData_hangye=this.cover_msg.result_msg
                    this.assetsTable.admin_doc.filename=this.cover_msg.filename;
                    this.assetsTable.accounting_id=this.cover_msg.result_msg.accounting_id;
                    this.assetsTable.add_type=this.cover_msg.result_msg.add_type;
                    this.assetsTable.admin_id=this.cover_msg.result_msg.admin_id;
                    this.assetsTable.class_code=this.cover_msg.result_msg.class_code;
                    this.assetsTable.count=this.cover_msg.result_msg.count;
                    this.assetsTable.department=this.cover_msg.result_msg.department;
                    this.assetsTable.depreciation=this.cover_msg.result_msg.depreciation;
                    this.assetsTable.entry_date=this.cover_msg.result_msg.entry_date;
                    this.assetsTable.full_price=this.cover_msg.result_msg.full_price;
                    this.assetsTable.model=this.cover_msg.result_msg.model;
                    this.assetsTable.name =this.cover_msg.result_msg.name;
                    this.assetsTable.net_value =this.cover_msg.result_msg.net_value;
                    this.assetsTable.unit =this.cover_msg.result_msg.unit;
                    this.assetsTable.company =this.cover_msg.result_msg.company;
                    this.assetsTable.entry_type =this.cover_msg.result_msg.entry_type;
                    this.assetsTable.finance_person =this.cover_msg.result_msg.finance_person;
                    this.assetsTable.location =this.cover_msg.result_msg.location;
                    this.assetsTable.use_state =this.cover_msg.result_msg.use_state;
                    this.assetsTable.remarks =this.cover_msg.result_msg.remarks;
                    this.assetsTable.keeper =this.cover_msg.result_msg.keeper;
                    this.assetsTable.belonged =this.cover_msg.result_msg.belonged;
                }else if(this.cover_msg.type=='Yonyou'){
                    console.log(this.cover_msg.result_msg);
                    this.check_yonyou_msg=this.cover_msg.check_msg.check
                    this.upData_yongyou=this.cover_msg.result_msg
                    this.assetsTable.yonyou_doc={filename:that.cover_msg.filename,path:that.cover_msg.path};
                    this.assetsTable.count=this.cover_msg.result_msg.count;
                    this.assetsTable.full_price=this.cover_msg.result_msg.full_price;
                    this.assetsTable.model=this.cover_msg.result_msg.model;
                    this.assetsTable.name=this.cover_msg.result_msg.name;
                    this.assetsTable.net_value =this.cover_msg.result_msg.net_value;
                    this.assetsTable.unit=this.cover_msg.result_msg.unit;
                    this.assetsTable.add_date =this.cover_msg.result_msg.add_date;
                    this.assetsTable.add_type =this.cover_msg.result_msg.add_type;
                    this.assetsTable.build_area =this.cover_msg.result_msg.build_area;
                    this.assetsTable.class_code =this.cover_msg.result_msg.class_code;
                    this.assetsTable.department =this.cover_msg.result_msg.department;
                    this.assetsTable.fund_source =this.cover_msg.result_msg.fund_source;
                    this.assetsTable.keeper =this.cover_msg.result_msg.keeper;
                    this.assetsTable.plate_number =this.cover_msg.result_msg.plate_number;
                    this.assetsTable.yonyou_id =this.cover_msg.result_msg.yonyou_id;
                    this.assetsTable.cancel_date =this.cover_msg.result_msg.cancel_date;
                    this.assetsTable.cancel_person =this.cover_msg.result_msg.cancel_person;
                    this.assetsTable.change_date =this.cover_msg.result_msg.change_date;
                    this.assetsTable.change_dep =this.cover_msg.result_msg.change_dep;
                    this.assetsTable.cut_type =this.cover_msg.result_msg.cut_type;
                    this.assetsTable.class_code =this.cover_msg.result_msg.class_code;
                    this.assetsTable.manufacturer =this.cover_msg.result_msg.manufacturer;
                    this.assetsTable.square =this.cover_msg.result_msg.square;
                    this.assetsTable.supplier =this.cover_msg.result_msg.supplier;
                    this.assetsTable.use_year =this.cover_msg.result_msg.use_year;
                    this.assetsTable.use_state =this.cover_msg.result_msg.use_state;
                    this.assetsTable.remarks =this.cover_msg.result_msg.remarks;
                }
                this.modal3=false

            },
            //下载固定资产验收单
            download_asets:function () {
                let that = this;
                let params = {};
                params.data = {
                    "path" : that.assetsTable.asset_doc
                };
              console.log(params.data);
              params.url = "/manage/messagelist/download";
                params.token = window.localStorage.getItem("token");
                params.success=function(res){
                    var blob = new Blob([res.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'}); //application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
                    var downloadElement = document.createElement('a');
                    var href = window.URL.createObjectURL(blob); //创建下载的链接
                    downloadElement.href = href;
                    downloadElement.download = '固定资产验收单' //下载后文件名
                    document.body.appendChild(downloadElement);
                    downloadElement.click(); //点击下载
                    document.body.removeChild(downloadElement); //下载完成移除元素
                    window.URL.revokeObjectURL(href); //释放掉blob对象
                }
                that.ajaxGet(params);

            },
            //上传文件成功回掉
            handleSuccess (res,file) {
                console.log(res);
                console.log(file);
                var that=this;
                var obj={};
                obj.filename=res.result.filename;
                obj.path=res.result.path;
                console.log(obj);
                switch (res.result.type){
                    case 'Admin':
                        that.check_hangye_msg=res.result.check_msg.check;
                        if(res.result.check_msg.check==false){
                            that.modal3=true;
                            that.error_msg=res.result.check_msg.error_msg;
                            that.cover_msg=res.result
                        }else{
                            that.check_hangye_msg=res.result.check_msg.check
                            that.upData_hangye=res.result.result_msg
                            that.assetsTable.admin_doc=obj;
                            that.assetsTable.accounting_id=res.result.result_msg.accounting_id;
                            that.assetsTable.add_type=res.result.result_msg.add_type;
                            that.assetsTable.admin_id=res.result.result_msg.admin_id;
                            that.assetsTable.class_code=res.result.result_msg.class_code;
                            that.assetsTable.count=res.result.result_msg.count;
                            that.assetsTable.department=res.result.result_msg.department;
                            that.assetsTable.depreciation=res.result.result_msg.depreciation;
                            that.assetsTable.entry_date=res.result.result_msg.entry_date;
                            that.assetsTable.full_price=res.result.result_msg.full_price;
                            that.assetsTable.model=res.result.result_msg.model;
                            that.assetsTable.name =res.result.result_msg.name;
                            that.assetsTable.net_value =res.result.result_msg.net_value;
                            that.assetsTable.unit =res.result.result_msg.unit;
                            that.assetsTable.company =res.result.result_msg.company;
                            that.assetsTable.entry_type =res.result.result_msg.entry_type;
                            that.assetsTable.finance_person =res.result.result_msg.finance_person;
                            that.assetsTable.location =res.result.result_msg.location;
                            that.assetsTable.use_state =res.result.result_msg.use_state;
                            that.assetsTable.remarks =res.result.result_msg.remarks;
                            that.assetsTable.keeper =res.result.result_msg.keeper;
                            that.assetsTable.belonged =res.result.result_msg.belonged;
                        }
//                        that.upData_hangye=res.result.filename;
                        break;
                    case 'Yonyou':
                        if(res.result.check_msg.check==false){
                            that.modal3=true;
                            that.error_msg=res.result.check_msg.error_msg;
                            that.cover_msg=res.result
                        }else{
                            that.check_yonyou_msg=res.result.check_msg.check
                            that.upData_yongyou=res.result.result_msg
                            that.assetsTable.yonyou_doc=obj;
                            that.assetsTable.count=res.result.result_msg.count;
                            that.assetsTable.full_price=res.result.result_msg.full_price;
                            that.assetsTable.model=res.result.result_msg.model;
                            that.assetsTable.name=res.result.result_msg.name;
                            that.assetsTable.net_value =res.result.result_msg.net_value;
                            that.assetsTable.unit=res.result.result_msg.unit;
                            that.assetsTable.add_date =res.result.result_msg.add_date;
                            that.assetsTable.add_type =res.result.result_msg.add_type;
                            that.assetsTable.build_area =res.result.result_msg.build_area;
                            that.assetsTable.class_code =res.result.result_msg.class_code;
                            that.assetsTable.department =res.result.result_msg.department;
                            that.assetsTable.fund_source =res.result.result_msg.fund_source;
                            that.assetsTable.keeper =res.result.result_msg.keeper;
                            that.assetsTable.plate_number =res.result.result_msg.plate_number;
                            that.assetsTable.yonyou_id =res.result.result_msg.yonyou_id;
                            that.assetsTable.cancel_date =res.result.result_msg.cancel_date;
                            that.assetsTable.cancel_person =res.result.result_msg.cancel_person;
                            that.assetsTable.change_date =res.result.result_msg.change_date;
                            that.assetsTable.change_dep =res.result.result_msg.change_dep;
                            that.assetsTable.cut_type =res.result.result_msg.cut_type;
                            that.assetsTable.class_code =res.result.result_msg.class_code;
                            that.assetsTable.manufacturer =res.result.result_msg.manufacturer;
                            that.assetsTable.square =res.result.result_msg.square;
                            that.assetsTable.supplier =res.result.result_msg.supplier;
                            that.assetsTable.use_year =res.result.result_msg.use_year;
                            that.assetsTable.use_state =res.result.result_msg.use_state;
                            that.assetsTable.remarks =res.result.result_msg.remarks;

                        }
                        break;
                }
                this.$Message.success('上传成功')
            },
            isLoading:function () {
                this.loading=true
            },
            //上传图片回调
            handleUploadSuccess:function (res,file) {
                console.log(res);
                console.log(file);
                this.loading=false;

                let uploadFilePath = res.result.path.substring(0);
                var that=this;
                switch (res.result.type){
                    case 'Contract':
                      console.log(this.assetsTable.contract_image);
                      this.assetsTable.contract_image.push(uploadFilePath);
                        if(res.result.read_img.project_name!=''){
                            that.assetsTable.project_name=res.result.read_img.project_name
                        }
                        break;
                    case 'Invoice':
                      console.log(that.assetsTable);
                      this.assetsTable.invoice_image.push(uploadFilePath);
                        this.assetsTable.count=res.result.read_img.count;
                        this.assetsTable.entry_date=res.result.read_img.entry_date;
                        this.assetsTable.full_price=res.result.read_img.full_price;
                        this.assetsTable.invoice_number=res.result.read_img.invoice_number;
                        this.assetsTable.model=res.result.read_img.model;
                        this.assetsTable.name=res.result.read_img.name;
                        this.assetsTable.net_value =res.result.read_img.net_value;
                        this.assetsTable.unit=res.result.read_img.unit;
                        break;
                    case 'Asset':
                        this.assetsTable.asset_image.push(uploadFilePath);
                        break;
                }
            },
            //删除上传的文件
            handleUploadRemove:function (file,fileList) {
                this.$Modal.confirm({
                    content:'确定删除该图片？',
                    onOk:function () {
                        fileList.removeByValue(file);
                    }
                })
            },
            //
            handleFormatError:function (file) {
                this.$Modal.error({content:'文件格式不对，请上传jpg或png格式的图片'})
            },
            handleError:function (file) {
                this.$Modal.error({content:'文件格式不对，请上传xls格式的文件'})
            },
            //查看大图
            handleView:function (visible,imagePath) {
                this.imageViewVisible = visible;
                this.viewPath = imagePath;
            },
            cancel:function () {
                this.$router.push('asetsList')
            },
            getParams:function () {
                // 取到路由带过来的参数
                let routerParams = this.$route.params
                console.log(routerParams);
                if(JSON.stringify(routerParams)=='{}'){
                    this.updateTitle='资产信息提取';
                }else{
                    this.updateTitle='资产信息修改';
                    this.assetsTable=routerParams;
                    this.show_bill=true
                    if(this.assetsTable.state=='已报废'||this.assetsTable.state=='待报废'){
                        this.isScrap=false;
                    }
                    if(this.assetsTable.count!=this.assetsTable.can_use_count){
                        this.edit_count=true
                    }
                    console.log(this.assetsTable);
                }
                // 将数据放在当前组件的数据内

            }
        },
        mounted: function () {
            this.getParams()
            this.getDepartment()
            console.log(this.assetsTable);


        },
        watch: {
            // 监测路由变化,只要变化了就调用获取路由参数方法将数据存储本组件即可
            '$route': 'getParams'
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/propertyMana/buildAsets.vue